var __webpack_error__ = new Error();
module.exports = new Promise((resolve, reject) => {
	if(typeof bizhq_maps_mfe !== "undefined") return resolve();
	__webpack_require__.l("/bizhq-grout-ui-mfe/mf-manifest.json", (event) => {
		if(typeof bizhq_maps_mfe !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "bizhq_maps_mfe");
}).then(() => (bizhq_maps_mfe));